import React from "react";
import { SvgWithSizeProps } from "../interfaces";

const SVGShare = ({
  color = "#FFF",
  className,
  size = 24,
}: SvgWithSizeProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.7547 24H6.24792C4.59192 23.998 3.00428 23.3395 1.83308 22.1687C0.661874 20.998 0.00272837 19.4106 9.15527e-05 17.7546V6.24787C0.00206938 4.59144 0.660951 3.00342 1.83223 1.83215C3.0035 0.660874 4.59149 0.00197783 6.24792 0H9.82279V3.26594H6.24792C5.45508 3.26594 4.69476 3.58089 4.13413 4.14151C3.57351 4.70214 3.25851 5.4625 3.25851 6.25534V17.7621C3.25851 18.5549 3.57351 19.3153 4.13413 19.8759C4.69476 20.4365 5.45508 20.7515 6.24792 20.7515H17.7547C18.5476 20.7515 19.3079 20.4365 19.8685 19.8759C20.4291 19.3153 20.7441 18.5549 20.7441 17.7621V14.1773H24.01V17.7546C24.008 19.4121 23.3481 21.001 22.1751 22.1721C21.0021 23.3432 19.4122 24.0007 17.7547 24Z"
      fill={color}
    />
    <path
      d="M13.5246 0V3.26594H18.4248L9.98213 11.7085L12.2915 14.0179L20.7341 5.57525V10.4754H24V1.65664C24.0003 1.4392 23.9578 1.22384 23.8748 1.02286C23.7918 0.821882 23.67 0.639237 23.5164 0.485372C23.3628 0.331507 23.1803 0.209439 22.9794 0.126155C22.7786 0.0428712 22.5633 -2.46582e-07 22.3459 0H13.5246Z"
      fill={color}
    />
  </svg>
);

export default SVGShare;
